import React, {Component} from "react";
import {Modal} from "react-bootstrap";
import DataTable from "react-data-table-component";
import {connect} from "react-redux";
import {toast} from "react-toastify";
import {
    CustomerCustomersList,
    CustomerDiscountGroup,
    CustomerMembership,
} from "../../../../redux/actions/Modules.Action";
import ApiConnect from "../../../../Utils/ApiConnect";
import AutoComplete from "../../../Components/AutoComplete";
import DeletePop from "../../../Components/DeletePop";

class index extends Component {
  constructor(props) {
    super(props);
this.state = {
      showModal: false,
      triggerModal: false,
      selectedId: false,
      btnDisable: false,
      formError: false,
      filterText: "",
    };
    this.columns = [
      {
        name: "Customer",
        selector: row => row.name,
        cell: (row) => {
          return (
            <React.Fragment>
              <div className="d-inline">
                {row.name}{" "}
                <span className="material-icons-outlined text-success fs-15">
                  verified
                </span>
              </div>
            </React.Fragment>
          );
        },
      },
      {
        name: "Contact",
        selector: row => row.id,
      },

      {
        name: "Discount",
        selector: row => row.discount,
      },
      {
        name: "Last Invoice",
        selector: row => row.last_invoice,
      },
      {
        name: "Last Update",
        selector: row => row.last_visit,
      },
      {
        name: "Action",
        selector: row => row.action,
        className: "table-actions",
        width: "150px",
        sortable: false,
        cell: (row) => {
          return (
            <React.Fragment>
              <button className="table-action btn btn-square btn-pure hover-warning">
                <span className="material-icons-outlined">edit_note</span>
              </button>
              <button
                className="table-action btn btn-square btn-pure hover-danger"
                onClick={() =>
                  this.setState({ selectedId: row.id, triggerModal: true })
                }
              >
                <span className="material-icons-outlined">delete</span>
              </button>
            </React.Fragment>
          );
        },
      },
      ];
  }

  customStyles = {
    headCells: {
      style: {
        padding: "12px 16px",
        fontWeight: "bold",
        fontSize: "14px",
        backgroundColor: "#f8f9fa",
      },
    },
    cells: {
      style: {
        padding: "10px 16px",
        fontSize: "13px",
      },
    },
  };

  componentDidMount() {
    this.fetchMembers();
    this.fetchDiscountAndMember();
  }
  fetchMembers = () => {
    ApiConnect.get("/Members/Information/MembershipList")
      .then((response) => {
        this.props.CustomerMembership(response.data);
      })
      .catch((error) => console.log(error));
  };
  fetchDiscountAndMember() {
    ApiConnect.get("/Members/Information/CustomerList")
      .then((response) => {
        this.props.CustomerCustomersList(response.data.data);
      })
      .catch((error) => console.log(error));
    ApiConnect.get("/Members/Information/DiscountGroup")
      .then((response) => {
        this.props.CustomerDiscountGroup(response.data);
      })
      .catch((error) => console.log(error));
  }

  autocompleteAction = (data) => {
    this.setState({ customername: data.name, customerid: data.id });
  };
  handleSubmit(e) {
    e.preventDefault();
    this.setState({ btnDisable: true });
    var Fdata = new FormData();
    Fdata.append("name", this.state.customername);
    Fdata.append("contact", this.state.customerid);
    Fdata.append("discount", this.state.discount);
    ApiConnect({
      method: "post",
      url: "/Members/Information/NewMembership",
      data: Fdata,
    })
      .then((response) => {
        this.setState({ btnDisable: false });
        if (response.data.status === 406) {
          this.setState({ formError: response.data.message });
        } else if (response.data.status === 201) {
          toast.success(response.data.message, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            draggableDirection: "y",
          });
          this.setState({
            showModal: false,
            triggerModal: false,
            selectedId: false,
            customername: "",
            customerid: "",
            discount: "",
            formError: false,
            btnDisable: false,
          });
          this.fetchMembers();
        } else if (response.data.status) {
          this.setState({ formError: response.data.message });
        }
      })
      .catch((error) => console.log(error));
  }
  SettriggerModal = () => {
    this.setState({ selectedId: false, triggerModal: false });
  };
  render() {
    return (
      <div className="col-md-12 col-xl-12">
        <div className="card">
          <header className="header no-border">
            <div className="header-info">
              <div className="left">
                <h2 className="header-title">
                  <strong>Membership</strong>
                </h2>
              </div>
              <div className="right gap-items-2">
                <button
                  className="btn btn-primary  btn-float btn-round"
                  onClick={() => {
                    this.setState({ showModal: true });
                  }}
                >
                  <span className="material-icons-outlined">add</span>
                </button>
              </div>
            </div>
            <div className="header-action"></div>
          </header>
          <div className="card-body">
            <div className="dataTables_wrapper">
              <div className="mb-3">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search..."
                  onChange={e => this.setState({ filterText: e.target.value })}
                />
              </div>
              <DataTable
                className="table table-separated"
                keyField="id"
                columns={this.columns}
                data={this.props.Membership.filter(item =>
                  Object.values(item).some(val =>
                    String(val).toLowerCase().includes(this.state.filterText.toLowerCase())
                  )
                )}
                pagination
                paginationRowsPerPageOptions={[10, 20, 30, 50, 100]}
                paginationPerPage={10}
                customStyles={this.customStyles}
                filter
                exportable
              />
            </div>
          </div>
          <Modal
            show={this.state.showModal}
            className="modal-center"
            onHide={() => this.setState({ showModal: false })}
          >
            <Modal.Dialog>
              <Modal.Header>
                <h5 className="modal-title">New Member</h5>
                <button
                  type="button"
                  className="btn"
                  onClick={(e) => this.setState({ showModal: false })}
                >
                  <span>×</span>
                </button>
              </Modal.Header>
              <form onSubmit={(e) => this.handleSubmit(e)}>
                <Modal.Body>
                  <p className="text-danger">{this.state.formError}</p>
                  <div className="row form-group">
                    <div className="col">
                      <label className="form-label">Customer Contact</label>
                      {this.props.CustomerList ? (
                        <AutoComplete
                          name="Customer"
                          action={this.autocompleteAction}
                          placeHolder="Customer Name"
                          items={this.props.CustomerList}
                        />
                      ) : (
                        ""
                      )}
                    </div>
                    <div className="col">
                      <label className="form-label">Discount Group</label>
                      <label className="col-12">
                        <select
                          className="form-control"
                          name="group"
                          value={this.state.discount}
                          onChange={(e) =>
                            this.setState({ discount: e.target.value })
                          }
                        >
                          <option>Select Group</option>
                          {this.props.Discount.map((group, index) => (
                            <option value={group.id} key={`${group}${index}`}>
                              {group.name}
                            </option>
                          ))}
                        </select>
                      </label>
                    </div>
                  </div>
                </Modal.Body>
                <Modal.Footer>
                  <button
                    type="submit"
                    className="btn btn-success"
                    disabled={this.state.btnDisable}
                  >
                    Create
                  </button>
                </Modal.Footer>
              </form>
            </Modal.Dialog>
          </Modal>
          <DeletePop
            trigger={this.state.triggerModal}
            delUrl={`/Members/Information/DeleteMembership?id=${this.state.selectedId}`}
            hideTrigger={this.SettriggerModal}
            fallAction={this.fetchMembers}
          />
        </div>
      </div>
    );
  }
}
export default connect(
  (state) => ({
    Membership: state.Customer.Membership,
    Discount: state.Customer.Discount,
    CustomerList: state.Customer.CustomerList,
  }),
  { CustomerMembership, CustomerDiscountGroup, CustomerCustomersList }
)(index);
